import { Component, Element, h, Host, Listen, Prop, State } from "@stencil/core";
import { debounce } from "../../utils/debounce";

@Component({
    tag: "ux-steps",
    styleUrl: "steps.scss",
    shadow: true
})
export class Steps {
    @Element() element!: HTMLUxStepsElement;

    /** this value is representing the current active step */
    @Prop() readonly current: number = 0;
    /** this value is representing number of steps */
    @Prop() readonly items: number = 0;

    /**
     * creates step-items
     * @param {Number} n number of items in indicator
     */
    private createSteps(n: number) {
        const stepElements = [];
        for (let i = 1; i < n + 1; i++) {
            stepElements.push(<ux-steps-item number={i} current={i === this.current} done={i < this.current} />);
        }
        return stepElements;
    }

    componentWillLoad() {
        this.getBottomGutter();
    }

    @Listen("resize", { target: "window" })
    onResize() {
        this.updateBottomGutter();
    }

    private updateBottomGutter = debounce(() => {
        this.getBottomGutter();
    }, 200);

    @State() bottomGutter = 0;

    private getBottomGutter = () => {
        // @ts-expect-error Check for typing
        const stepItems = Array.from(this.element.shadowRoot.querySelectorAll("ux-steps-item"));
        // @ts-expect-error Check for typing
        let stepText = stepItems.map((stepItem) => stepItem.shadowRoot.querySelector("p"));
        if (stepText.length === 0) {
            // @ts-expect-error Check for typing
            const slot = this.element.shadowRoot.querySelector("slot");
            if (!slot) return;
            const assignedElements = slot.assignedElements();
            // @ts-expect-error Check for typing
            stepText = assignedElements.map((assignedElement) => assignedElement.shadowRoot.querySelector("p"));
        }

        if (stepText.length === 0) return; // no step text found

        const heights: number[] = [];
        stepText.forEach((stepText) => {
            // @ts-expect-error Check for typing
            const height = stepText.getBoundingClientRect().height;
            heights.push(height + (height > 0 ? 10 : 0));
        });
        this.bottomGutter = Math.max(...heights);
        this.element.style.setProperty("--ux-steps-item-padding-bottom", `${this.bottomGutter}px`);
    };

    render() {
        const baseClass = "ux-steps";
        return (
            <Host generated={this.items > 0} aria-label="progress">
                <div aria-hidden="true" class={`${baseClass}__outer-line ${baseClass}__outer-line--left `}></div>
                <div class={`${baseClass}__indicators`}>
                    {this.createSteps(this.items)}
                    <slot onSlotchange={() => this.getBottomGutter()} />
                </div>
                <div aria-hidden="true" class={`${baseClass}__outer-line ${baseClass}__outer-line--right `}></div>
            </Host>
        );
    }
}
